<template>
  <table>
    <tbody>
      <tr class="syllabary-panel">
        <td><input type="button" @click="clickedButton(['あ'])" :class="{'clicked': clickedValue === 'あ'}" value="あ" ></td>
        <td><input type="button" @click="clickedButton(['か','が'])" :class="{'clicked': clickedValue === 'か'}" value="か"></td>
        <td><input type="button" @click="clickedButton(['さ', 'ざ'])" :class="{'clicked': clickedValue === 'さ'}" value="さ"></td>
        <td><input type="button" @click="clickedButton(['た', 'だ'])" :class="{'clicked': clickedValue === 'た'}" value="た"></td>
        <td><input type="button" @click="clickedButton(['な'])" :class="{'clicked': clickedValue === 'な'}" value="な"></td>
        <td><input type="button" @click="clickedButton(['は', 'ば', 'ぱ'])" :class="{'clicked': clickedValue === 'は'}" value="は"></td>
        <td><input type="button" @click="clickedButton(['ま'])" :class="{'clicked': clickedValue === 'ま'}" value="ま"></td>
        <td><input type="button" @click="clickedButton(['や'])" :class="{'clicked': clickedValue === 'や'}" value="や"></td>
        <td><input type="button" @click="clickedButton(['ら'])" :class="{'clicked': clickedValue === 'ら'}" value="ら"></td>
        <td><input type="button" @click="clickedButton(['わ'])" :class="{'clicked': clickedValue === 'わ'}" value="わ"></td>
      </tr>
      <tr class="syllabary-panel">
        <td><input type="button" @click="clickedButton(['い'])" :class="{'clicked': clickedValue === 'い'}" value="い"></td>
        <td><input type="button" @click="clickedButton(['き', 'ぎ'])" :class="{'clicked': clickedValue === 'き'}" value="き"></td>
        <td><input type="button" @click="clickedButton(['し', 'じ'])" :class="{'clicked': clickedValue === 'し'}" value="し"></td>
        <td><input type="button" @click="clickedButton(['ち'])" :class="{'clicked': clickedValue === 'ち'}" value="ち"></td>
        <td><input type="button" @click="clickedButton(['に'])" :class="{'clicked': clickedValue === 'に'}" value="に"></td>
        <td><input type="button" @click="clickedButton(['ひ', 'び', 'ぴ'])" :class="{'clicked': clickedValue === 'ひ'}" value="ひ"></td>
        <td><input type="button" @click="clickedButton(['み'])" :class="{'clicked': clickedValue === 'み'}" value="み"></td>
        <td><input type="button" disabled></td>
        <td><input type="button" @click="clickedButton(['り'])" :class="{'clicked': clickedValue === 'り'}" value="り"></td>
        <td><input type="button" disabled></td>
      </tr>
      <tr class="syllabary-panel">
        <td><input type="button" @click="clickedButton(['う'])" :class="{'clicked': clickedValue === 'う'}" value="う"></td>
        <td><input type="button" @click="clickedButton(['く', 'ぐ'])" :class="{'clicked': clickedValue === 'く'}" value="く"></td>
        <td><input type="button" @click="clickedButton(['す', 'ず'])" :class="{'clicked': clickedValue === 'す'}" value="す"></td>
        <td><input type="button" @click="clickedButton(['つ'])" :class="{'clicked': clickedValue === 'つ'}" value="つ"></td>
        <td><input type="button" @click="clickedButton(['ぬ'])" :class="{'clicked': clickedValue === 'ぬ'}" value="ぬ"></td>
        <td><input type="button" @click="clickedButton(['ふ', 'ぶ', 'ぷ'])" :class="{'clicked': clickedValue === 'ふ'}" value="ふ"></td>
        <td><input type="button" @click="clickedButton(['む'])" :class="{'clicked': clickedValue === 'む'}" value="む"></td>
        <td><input type="button" @click="clickedButton(['ゆ'])" :class="{'clicked': clickedValue === 'ゆ'}" value="ゆ"></td>
        <td><input type="button" @click="clickedButton(['る'])" :class="{'clicked': clickedValue === 'る'}" value="る"></td>
        <td><input type="button" @click="clickedButton(['を'])" value="を" disabled></td>
      </tr>
      <tr class="syllabary-panel">
        <td><input type="button" @click="clickedButton(['え'])" :class="{'clicked': clickedValue === 'え'}" value="え"></td>
        <td><input type="button" @click="clickedButton(['け', 'げ'])" :class="{'clicked': clickedValue === 'け'}" value="け"></td>
        <td><input type="button" @click="clickedButton(['せ', 'ぜ'])" :class="{'clicked': clickedValue === 'せ'}" value="せ"></td>
        <td><input type="button" @click="clickedButton(['て', 'で'])" :class="{'clicked': clickedValue === 'て'}" value="て"></td>
        <td><input type="button" @click="clickedButton(['ね'])" :class="{'clicked': clickedValue === 'ね'}" value="ね"></td>
        <td><input type="button" @click="clickedButton(['へ', 'べ', 'ぺ'])" :class="{'clicked': clickedValue === 'へ'}" value="へ"></td>
        <td><input type="button" @click="clickedButton(['め'])" :class="{'clicked': clickedValue === 'め'}" value="め"></td>
        <td><input type="button" disabled></td>
        <td><input type="button" @click="clickedButton(['れ'])" :class="{'clicked': clickedValue === 'れ'}" value="れ"></td>
        <td><input type="button" disabled></td>
      </tr>
      <tr class="syllabary-panel">
        <td><input type="button" @click="clickedButton(['お'])" :class="{'clicked': clickedValue === 'お'}" value="お"></td>
        <td><input type="button" @click="clickedButton(['こ', 'ご'])" :class="{'clicked': clickedValue === 'こ'}" value="こ"></td>
        <td><input type="button" @click="clickedButton(['そ', 'ぞ'])" :class="{'clicked': clickedValue === 'そ'}" value="そ"></td>
        <td><input type="button" @click="clickedButton(['と', 'ど'])" :class="{'clicked': clickedValue === 'と'}" value="と"></td>
        <td><input type="button" @click="clickedButton(['の'])" :class="{'clicked': clickedValue === 'の'}" value="の"></td>
        <td><input type="button" @click="clickedButton(['ほ', 'ぼ', 'ぽ'])" :class="{'clicked': clickedValue === 'ほ'}" value="ほ"></td>
        <td><input type="button" @click="clickedButton(['も'])" :class="{'clicked': clickedValue === 'も'}" value="も"></td>
        <td><input type="button" @click="clickedButton(['よ'])" :class="{'clicked': clickedValue === 'よ'}" value="よ"></td>
        <td><input type="button" @click="clickedButton(['ろ'])" :class="{'clicked': clickedValue === 'ろ'}" value="ろ"></td>
        <td><input type="button" @click="clickedButton(['ん'])" value="ん" disabled></td>
      </tr>
      <tr class="alphanumeric-panel">
        <td><input type="button" @click="clickedButton(['ABC'], '[A-Za-z]')" value="ABC"></td>
        <td><input type="button" @click="clickedButton(['数字'], '[0-9]')" value="数字"></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  data () {
    return {
      clickedValue: null
    }
  },
  methods: {
    clickedButton (value, pattern) {
      this.clickedValue = value[0]
      this.$emit('clickCharacterSelectorButton', value, pattern)
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
}
tr {
  display: flex;
  align-items: center;
}
td {
  padding: 5px;
  text-align: center;
}
input {
  display: block;
  -webkit-appearance: none;
  border-radius: 0;
}
.clicked {
  background-color: #027bfed1;
  color: white;
}
.syllabary-panel {
  justify-content: space-between;
  input {
    width: 30px;
  }
}
.alphanumeric-panel {
  justify-content: center;
  gap: 50px;
  input {
    width: 50px;
  }
}

// TODO: 後ほど変数を利用するように修正
@media screen and (max-width: 575px) {
  tbody {
    display: flex;
    justify-content: space-around;
    width: 100%;
    flex-direction: row;
  }
  tr {
    flex-direction: column;
  }
}
</style>
